import script from "./UserBackpack.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBackpack.vue?vue&type=script&setup=true&lang=js"

import "./UserBackpack.vue?vue&type=style&index=0&id=04f24bae&lang=scss"

const __exports__ = script;

export default __exports__